export function evalStringTemplate(template: string, data: object): string {
  for (const [key, value] of Object.entries(data)) {
    template = template.replace(new RegExp(`\\\${${key}}`, 'g'), value)
  }
  return template
}